import { ADDRESS_SHIPPING_CATEGORY } from 'services/constants/cart';
import type { CartAddressData } from 'services';
import { DESTINATION_TYPE_BY_SHIPPING_CATEGORY } from '../../../constants';
import type { DestinationType } from '../../../types';

function isShippingAddressCategory(
  category: NonNullable<CartAddressData['category']>
): category is keyof typeof DESTINATION_TYPE_BY_SHIPPING_CATEGORY {
  return Object.values(ADDRESS_SHIPPING_CATEGORY).some(validCategory => String(validCategory) === String(category));
}

/** Maps a saved shipping category to its destination type. */
export function getDestinationTypeFromShippingCategory(
  category?: CartAddressData['category']
): DestinationType | undefined {
  if (category === undefined || !isShippingAddressCategory(category)) {
    return undefined;
  }

  return DESTINATION_TYPE_BY_SHIPPING_CATEGORY[category];
}
